import { Link } from 'react-router-dom';

interface QuickAction {
  label: string;
  hint: string;
  icon: string;
  to: string;
}

const quickActions: QuickAction[] = [
  {
    label: 'Send to Bank',
    hint: 'Any bank, worldwide',
    icon: 'ri-bank-line',
    to: '/payments/send?flow=bank',
  },
  {
    label: 'Mobile Money',
    hint: 'M-PESA, Airtel & more',
    icon: 'ri-smartphone-line',
    to: '/payments/send?flow=mobile',
  },
  {
    label: 'Pay a Bill',
    hint: 'Utilities & services',
    icon: 'ri-file-list-2-line',
    to: '/payments/send?flow=bill',
  },
  {
    label: 'Buy Goods',
    hint: 'Pay merchants & till numbers',
    icon: 'ri-shopping-bag-3-line',
    to: '/payments/send?flow=goods',
  },
  {
    label: 'Buy Airtime',
    hint: 'Top up any line',
    icon: 'ri-sim-card-line',
    to: '/payments/send?flow=airtime',
  },
];

/**
 * Quick call-to-action tiles shown at the top of the Wallet page. Each tile
 * routes straight into the transfer flow so paying out is one tap away.
 */
export default function WalletQuickActions() {
  return (
    <section>
      <div className="mb-3 flex items-center justify-between">
        <h2 className="font-heading text-sm font-semibold text-foreground-950">
          Quick actions
        </h2>
        <span className="text-xs text-foreground-500">Pay out from your float in one tap</span>
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
        {quickActions.map((action) => (
          <Link
            key={action.label}
            to={action.to}
            className="choice-row group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3.5 transition-[border-color,background-color,transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:border-primary-300 hover:bg-primary-50 hover:shadow-md motion-reduce:hover:translate-y-0"
          >
            <span className="choice-icon flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${action.icon} text-lg`} />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block truncate text-sm font-medium text-foreground-950">
                {action.label}
              </span>
              <span className="block truncate text-xs text-foreground-500">{action.hint}</span>
            </span>
            <i className="choice-arrow ri-arrow-right-s-line shrink-0 text-foreground-400" />
          </Link>
        ))}
      </div>
    </section>
  );
}